import { QueryClient } from "@tanstack/react-query";

/**
 * Instance partagée de TanStack Query. Pas de `staleTime`/`retry` agressifs :
 * ce lot pose seulement la plomberie (`QueryClientProvider` dans `src/main.tsx`)
 * — les ateliers de pages suivants affineront ces réglages par requête selon
 * leurs besoins réels (listing catalogue vs. panier vs. tableau de bord admin).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
